export default __webpack_public_path__ + "static/media/add_rule_at_top.1f3ef165.svg";